import React from 'react';

interface SmallLoadingSpinnerProps {
  size?: 'xs' | 'sm' | 'md';
  className?: string;
}

const SmallLoadingSpinner: React.FC<SmallLoadingSpinnerProps> = ({ size = 'sm', className = '' }) => {
  const sizeClasses = {
    xs: 'w-3 h-3 border-2',
    sm: 'w-4 h-4 border-2', 
    md: 'w-6 h-6 border-2'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className={`${sizeClasses[size]} border-t-transparent border-blue-500 rounded-full animate-spin`}></div>
    </div>
  );
};

export default SmallLoadingSpinner;